import { Box, Breadcrumbs, Hidden, styled, useTheme } from '@mui/material';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import NavigateNextSharpIcon from '@mui/icons-material/NavigateNextSharp';
import menuItems from './SideBarItems';

const BreadcrumbRoot = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center'
});

const BreadcrumbName = styled('h4')(({ theme }) => ({
  margin: 0,
  fontSize: '1.25rem',
  fontWeight: 600,
  paddingBottom: '1px',
  verticalAlign: 'middle',
  textTransform: 'capitalize',
  color: theme.palette.text.primary,
}));

const SubName = styled('span')(({ theme }) => ({
  fontSize: '0.95rem',
  textTransform: 'capitalize',
  color: theme.palette.text.secondary,
  transition: 'color 0.2s ease-in-out',
  '&:hover': {
    color: theme.palette.primary.main,
  },
}));

const Separator = styled('h4')(({ theme }) => ({
  margin: 0,
  marginLeft: 8,
  paddingBottom: '5px',
  color: theme.palette.text.disabled,
}));


const findBreadcrumbs = (path, items = menuItems, breadcrumbs = []) => {
  for (let item of items) {

    if (item.submenuItems) {
      const result = findBreadcrumbs(path, item.submenuItems, [...breadcrumbs, item]);
      if (result) return result;
    }

    if (item.to && path.includes(item.to)) {
      return [...breadcrumbs, item];
    }
  }
  return null;
};

const Breadcrumb = () => {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  const breadcrumbs = findBreadcrumbs(location.pathname);

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <Box mb={2} px={2}>
      <BreadcrumbRoot>
        {breadcrumbs ? (
          <Hidden xsDown>
            <BreadcrumbName>{breadcrumbs[breadcrumbs.length - 1].title}</BreadcrumbName>
            <Separator>|</Separator>
          </Hidden>
        ) : null}

        <Breadcrumbs
          separator={<NavigateNextSharpIcon sx={{ fontSize: 18, color: theme.palette.text.disabled }} />}
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            position: 'relative',
            '& .MuiBreadcrumbs-ol': {
              flexWrap: 'nowrap',
            },
          }}
        >
          <NavLink 
            to="/dashboard"
            style={{ 
              display: 'flex', 
              alignItems: 'center',
              color: theme.palette.primary.main,
              transition: 'color 0.2s ease-in-out',
            }}
            onMouseEnter={(e) => e.currentTarget.style.color = theme.palette.primary.dark}
            onMouseLeave={(e) => e.currentTarget.style.color = theme.palette.primary.main}
          >
            <HomeOutlinedIcon
              sx={{ 
                marginLeft: 1, 
                marginBottom: '4px', 
                verticalAlign: 'middle',
                fontSize: 20,
              }}
            />
          </NavLink>

          {breadcrumbs
            ? breadcrumbs.map((route, index) => {
              const isActive = location.pathname === route.to;

              return index !== breadcrumbs.length - 1 ? (
                <NavLink
                  key={index}
                  to={route.to}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation(route.to);
                  }}
                  style={{
                    textDecoration: 'none',
                  }}
                >
                  <SubName>{route.title}</SubName>
                </NavLink>
              ) : (
                <SubName key={index} sx={{ color: theme.palette.text.primary, fontWeight: 500 }}>
                  {route.title}
                </SubName>
              );
            })
            : null}
        </Breadcrumbs>
      </BreadcrumbRoot>
    </Box>
  );
};

export default Breadcrumb;
